interface ComputerWithGraphSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithGraphSVG = ({ color, style }: ComputerWithGraphSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1753_36737)">
      <path
        d="M40.2708 0.556641C42.0114 0.556641 43.4237 1.96901 43.4237 3.70961V28.8439C43.4237 30.5845 42.0114 31.9969 40.2708 31.9969H4.21547C2.47487 31.9969 1.0625 30.5845 1.0625 28.8439V3.70961C1.0625 1.96901 2.47487 0.556641 4.21547 0.556641C5.41897 0.556641 41.3649 0.556641 40.2708 0.556641Z"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4413 32.0068L9.51172 36.8706H22.243H34.9742L33.0546 32.0068"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0538 40.5605L43.7438 47.2146C44.3008 48.2192 43.5747 49.4426 42.4309 49.4426H2.05894C0.915113 49.4426 0.189034 48.2192 0.746026 47.2146L4.4361 40.5605H40.0637H40.0538Z"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.168 24.5394V10.5449H24.9865V24.5394"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38281 24.4697V17H12.2014V24.6189"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9453 24.6189V17H37.7639V24.4697"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1901 11.7484C11.1901 12.7927 10.3447 13.6481 9.29037 13.6481C8.23606 13.6481 7.39062 12.8027 7.39062 11.7484C7.39062 10.6941 8.23606 9.84863 9.29037 9.84863C10.3447 9.84863 11.1901 10.6941 11.1901 11.7484Z"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7565 11.7484C36.7565 12.7927 35.9111 13.6481 34.8568 13.6481C33.8025 13.6481 32.957 12.8027 32.957 11.7484C32.957 10.6941 33.8025 9.84863 34.8568 9.84863C35.9111 9.84863 36.7565 10.6941 36.7565 11.7484Z"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9792 5.2933C23.9792 6.33766 23.1337 7.19304 22.0794 7.19304C21.0251 7.19304 20.1797 6.3476 20.1797 5.2933C20.1797 4.23899 21.0251 3.39355 22.0794 3.39355C23.1337 3.39355 23.9792 4.23899 23.9792 5.2933Z"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7188 6.24805L33.2175 10.7935"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9297 10.7935L20.4383 6.24805"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.9375 24.6182H40.5398"
        stroke={color}
        strokeWidth="1.11398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1753_36737">
        <rect width="44.4898" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithGraphSVG;
